export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD6eQ9so0lKUGzZ-UR9QtCf8RupxaU6G0A",
    authDomain: "testsol-f5817.firebaseapp.com",
    databaseURL: "https://testsol-f5817.firebaseio.com",
    projectId: "testsol-f5817",
    storageBucket: "testsol-f5817.appspot.com",
    messagingSenderId: "781919170620",
    appId: "1:781919170620:web:c24a2fd3fb196db38e1339"
  },
    apiUrl: 'https://testing.coopacsanmartin.pe/sol/'
};
